import { useState, type FormEvent } from 'react';
import { authApi } from '../../api/endpoints';
import { errorMessage, useFeedback } from '../../components/Feedback';
import { Modal } from '../../components/Modal';
import { Field } from '../../components/ui';

export const MIN_PASSWORD = 10;

export function PasswordModal({ onClose }: { onClose: () => void }) {
  const { notify } = useFeedback();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [error, setError] = useState<string | null>(null);

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    try {
      await authApi.changePassword(current, next);
      notify('Mot de passe modifié');
      onClose();
    } catch (e) {
      setError(errorMessage(e));
    }
  };

  return (
    <Modal title="Changer le mot de passe" onClose={onClose}>
      <form onSubmit={submit}>
        {error && <div className="error-box">{error}</div>}
        <Field label="Mot de passe actuel" htmlFor="pw-current">
          <input id="pw-current" className="input" type="password" autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} required />
        </Field>
        <Field label="Nouveau mot de passe" htmlFor="pw-next" hint={`${MIN_PASSWORD} caractères minimum`}>
          <input id="pw-next" className="input" type="password" autoComplete="new-password" minLength={MIN_PASSWORD} value={next} onChange={(e) => setNext(e.target.value)} required />
        </Field>
        <footer>
          <button type="button" className="btn" onClick={onClose}>Annuler</button>
          <button className="btn primary">Enregistrer</button>
        </footer>
      </form>
    </Modal>
  );
}
